import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable()
export class JiraService {
  env: any = environment;

  constructor(private http: HttpClient) {}

  getProjects(): any {
    return new Promise((resolve, reject) => {
      this.http
        .get<any>(this.env.managirUrl + "/jira/projects", {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async syncProject(id: string, progressId: string): Promise<any> {
    return this.http
      .post<any>(
        this.env.managirUrl + "/jira/syncProject/" + id,
        { progressId: progressId },
        { headers: { "Content-Type": "application/json" } }
      )
      .toPromise();
  }

  importProject(id: number, progressId: string) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl + "/jira/importProject",
          {
            id: id,
            progressId: progressId,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  authorize(jiraUrl: string): any {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl + "/jira/authorize",
          {
            url: jiraUrl,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/jira/jira.service.ts